import Vue from 'vue'
import App from './App.vue'
import router from './router'
import AV from 'leancloud-storage'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import axios from 'axios'
import utils from '@/components/urlGet'

AV.init({
  appId: 'YAH6SRS2Sk8iUNhFOY61TqaE-gzGzoHsz',
  appKey: 'vRg3i3dMpGPOijxOu803HaTW',
  serverURL: 'https://api.zz.hlingsoft.com'
})
Vue.use(Antd)
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.$utils = utils

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
